import { CONFIG } from '../../config'

/**
 * A request to the taker, which answers every `/api` and `/json` path.
 *
 * `API.URL` is the taker's origin. Deployed, that is the origin the app is served from, so the
 * request is same-origin; locally it is the cluster's taker, a different origin, and the taker
 * answers the preflight. No cookie is sent: every call names its round in the request itself.
 */
export function fetchApi(path: `/api/${string}` | `/json/${string}`, init: RequestInit) {
  return globalThis.fetch(`${CONFIG.API.URL}${path}`, init)
}
